import type { InvoiceIndexEntry } from '@/packages/api/src';

const DEFAULT_REFERENCE = 'INV-001';

/**
 * The most recent invoice reference, assuming the list is ordered newest-first
 * (as returned by the invoices index endpoint).
 */
export function getLastInvoiceReference(
    invoices: InvoiceIndexEntry[] | undefined | null
): string | null {
    if (!invoices || invoices.length === 0) {
        return null;
    }
    return invoices[0]!.reference;
}

/**
 * Suggest the next invoice reference by incrementing the trailing number of the
 * most recent invoice reference (e.g. "INV-007" -> "INV-008"). Falls back to
 * "INV-001" when there is no previous invoice or no trailing number.
 */
export function getNextInvoiceReference(
    invoices: InvoiceIndexEntry[] | undefined | null
): string {
    const lastReference = getLastInvoiceReference(invoices);
    if (lastReference === null) {
        return DEFAULT_REFERENCE;
    }

    const match = lastReference.match(/(.*?)(\d+)$/);
    if (match) {
        const prefix = match[1]!;
        const number = parseInt(match[2]!);
        const nextNumber = (number + 1).toString().padStart(3, '0');
        return `${prefix}${nextNumber}`;
    }

    return DEFAULT_REFERENCE;
}
